import { DeleteIcon as DeleteIconCopy } from '../../Assets/Images/svgs'

const DeleteIcon: React.FC = () => {
  return <DeleteIconCopy />
}

export default DeleteIcon
